<template>             
    <button type="button" class="btn btn-pmes-primary me-10 float-right"  :data-kt-indicator=" processando ? 'on' : 'off' " :disabled="disabled" >
        <span class="indicator-label">
        <i class="fa fa-save fs-2x"></i> {{ titulo ? translate( titulo ) : translate('salvar')   }}  
        </span>
        <span class="indicator-progress">
            {{  translate('processando') }}   
            <span
            class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
        </span>
    </button> 
</template>


<script lang="ts"> 
    import { Prop } from 'vue-property-decorator';  
    import { Options, Vue  } from "vue-class-component";   
    import { useI18n } from "vue-i18n";

    @Options({
        name: "BotaoSalvar",
        components: {  },  
    }) 
    export default class  BotaoSalvar extends Vue { 
        
        @Prop( ) readonly processando!: any 
        @Prop( ) readonly titulo!: any 
        @Prop( ) readonly disabled!: any 
          

        private t = useI18n().t;
        private te = useI18n().te; 
        public translate = text => {
            if (this.te(text)) {
                return this.t(text);
            } else {
                return text;
            } 
        }
    } 
</script>

<style scoped>
    button{
        float: right;
    }
</style>

